import type { FC } from 'react';
import { ProsConsLists } from '@/components/hub/ProsConsLists';
import type {
  BookmakerFeaturesCons,
  BookmakerFeaturesPros,
} from '@/types/bookmaker';
import MarkdownContent from '../MarkdownContent';
import { HubSectionTitle } from './SectionTitle';

interface OverviewSectionProps {
  title: string;
  text: string;
  pros: BookmakerFeaturesPros;
  cons: BookmakerFeaturesCons;
}

export const OverviewSection: FC<OverviewSectionProps> = ({
  title,
  text,
  pros,
  cons,
}) => {
  return (
    <div
      className="flex flex-col gap-3 rounded-lg bg-medium-gray p-4"
      id="overview"
    >
      <HubSectionTitle>{title}</HubSectionTitle>
      <MarkdownContent>{text ?? ''}</MarkdownContent>
      <ProsConsLists cons={cons} pros={pros} />
    </div>
  );
};
